import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class ImageSwiper extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;

        return (
            <div className={styles.newsList}>
                <ul className={styles.news}>
                    {
                        content.map((item, index) => {
                            return (
                                <li key={index}>
                                    <a className={styles.title} href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                    <span className={styles.time}>[{item.newsTime}]</span>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default ImageSwiper;
